import { useProduct } from "contexts/ProductContext";
import { actionErrored } from "utils/status";
import { getActionsByType } from "integrations/firebase/collections";
import { FinalKeywords } from "./components/FinalKeywords/FinalKeywords";
import { KeywordsError } from "./KeywordsError";
import { UnifiedKeywordsTable } from "./components/UnifiedKeywordsTable/UnifiedKeywordsTable";
import { useKeywordGeneration } from "./hooks/useKeywordGeneration";

interface KeywordsTabProps {
  showReasoning?: boolean;
}

export const KeywordsTab = ({ showReasoning = false }: KeywordsTabProps) => {
  const { product } = useProduct();
  const { generateKeywords } = useKeywordGeneration();

  if (!product) {
    return null;
  }

  const { keywords: keywordsActions } = getActionsByType(product);
  const action = keywordsActions?.generate;
  const isError = actionErrored(action);

  const handleGenerate = async () => {
    await generateKeywords();
  };

  return (
    <div className="flex flex-row gap-4 h-full">
      {isError ? (
        <KeywordsError
          onGenerate={handleGenerate}
          statusCode={action?.statusCode}
        />
      ) : (
        <UnifiedKeywordsTable showReasoning={showReasoning} />
      )}
      <FinalKeywords showReasoning={showReasoning} />
    </div>
  );
};
